import React, { useState, useEffect, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import SearchBar from "./serachBar";
import ProductList from "./ProductList";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./IlifeModal.scss";
import Ifern4pService from "../../../service/ifern4p/ifern4p";
import { Table } from "react-bootstrap";
import { AlertMessage } from "../common";
import { useSelector } from "react-redux";
import _ from "lodash";

function IlifeModal(props) {
  const { currentTheme } = useSelector((state) => state.Theme);
  const modalRef = useRef(null);
  const service = new Ifern4pService();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  //4p code generator
  const [accessCode, setAccessCode] = useState("");
  const [securityCode, setSecurityCode] = useState("");
  const [noOfAccount, setNoOfAccount] = useState(1);
  const [type, setType] = useState("automatic");
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState([]);
  const [pv, setPv] = useState(null);
  const [totalPv, setTotalpv] = useState();
  const [loadingStates, setLoadingStates] = useState({
    add: false,
    auto_add: false,
    register: false,
  });
  const [reorderActivation, setReorderActivation] = useState({
    username: "",
    activation_code: "",
    security_code: "",
  });
  const [fourpAccountPV, setFourpAccountPV] = useState(0);
  // Function to update the window width state when the window is resized
  const handleWindowResize = () => {
    setWindowWidth(window.innerHeight);
  };

  const handleModalContentClick = (e) => {
    // Prevent the click event from bubbling up to the wrapper div
    e.stopPropagation();
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const reorderChange = async (name, value) => {
    setReorderActivation({ ...reorderActivation, [name]: value });
    if (name == "username") {
      await debouncedGetFourpMaintenanceAmount(value);
    }
  };

  const clearReorder = () => {
    setReorderActivation({
      username: "",
      activation_code: "",
      security_code: "",
    });
  };
  //4p regiostration state
  const [accessCodeReg, setAccessCodeReg] = useState("");
  const [securityCodeReg, setSecurityCodeReg] = useState("");
  const [userNameEntry, setUserNameEntry] = useState("");
  const [sponsorUserName, setSponsorUserName] = useState("");
  const [placementUsername, setPlacementUsername] = useState("");
  const [position, setPosition] = useState("R");

  const ClearFourpRegistration = () => {
    setAccessCodeReg("");
    setSecurityCodeReg("");
    setUserNameEntry("");
    setSponsorUserName("");
    setPlacementUsername("");
    setPosition("R");
  };
  const notifyDissmissed = () => {
    setnotify((prev) => ({
      ...prev,
      show: false,
    }));
  };

  const [notify, setnotify] = useState({
    show: false,
    message: "",
    type: "",
  });

  const dissmissNotify = () => {
    setnotify((prev) => ({
      ...prev,
      show: false,
      message: "",
      type: "",
    }));
  };

  const maxHeight = windowWidth >= 768 ? "800px" : "280px";
  //4p code - generator

  const handleSubmit = async () => {
    let data = {};
    setLoadingStates({
      ...loadingStates,
      add: true,
    });
    try {
      if (response.length === 0 && (accessCode === "" || securityCode === "")) {
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "danger",
          message: "Access Code and Security Code Required",
        }));

        setLoadingStates({
          ...loadingStates,
          add: false,
        });
      } else if (response.length !== 0) {
        data = {
          code_array: [
            ...response,
            { access_code: accessCode, security_code: securityCode },
          ],
          no_of_account: noOfAccount,
          type: "manual",
        };
      } else {
        data = {
          code_array: [
            {
              access_code: accessCode,
              security_code: securityCode,
            },
          ],
          no_of_account: noOfAccount,
          type: "manual",
        };
      }
      if (accessCode.trim() != "" && securityCode.trim() != "") {
        const apiResponse = await service.register(data);
        console.log("fourp response in manual add", apiResponse);

        if (!apiResponse.status) {
          setnotify((prev) => ({
            ...prev,
            show: true,
            type: "danger",
            message: apiResponse.error.description ?? "Error Occured",
          }));
          setLoadingStates({
            ...loadingStates,
            add: false,
          });
        } else {
          //  the new entry to the response array
          setResponse((prevResponse) => {
            if (apiResponse.data.code_details[0] !== undefined) {
              for (let [key, value] of Object.entries(
                apiResponse.data.code_details
              )) {
                let newItem = value;
                const itemExists = prevResponse.some(
                  (item) => item.access_code === newItem.access_code
                );
                if (!itemExists) {
                  return [...prevResponse, newItem];
                }
              }
              // const newItem = apiResponse.data.code_details[0];
            }
            if (apiResponse.data.code_details.length == 0) {
              setnotify((prev) => ({
                ...prev,
                show: true,
                type: "danger",
                message: "Empty or Code is not activated.",
              }));
            }
            return prevResponse;
          });

          setPv(apiResponse?.data?.current_pv);
          setAccessCode("");
          setSecurityCode("");
          setTotalpv(apiResponse?.data?.required_pv);
          setLoadingStates({
            ...loadingStates,
            add: false,
          });
        }
      }
      console.log("fourp details after if part");
    } catch (error) {
      console.log(error);
      setLoadingStates({
        ...loadingStates,
        add: false,
      });
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: "Some Error Occured.Please Try Again.",
      }));
    }
  };

  const codeActivationSubmit = async () => {
    let data = {};
    setLoadingStates({
      ...loadingStates,
      reorder: true,
    });
    try {
      if (
        reorderActivation.username === "" ||
        reorderActivation.activation_code === "" ||
        reorderActivation.security_code === ""
      ) {
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "danger",
          message: "Access Code and Security Code and Username Required",
        }));
      } else {
        console.log(reorderActivation);
        data = {
          access_code: reorderActivation.activation_code,
          security_code: reorderActivation.security_code,
          username: reorderActivation.username,
        };

        const apiResponse = await service.fourpReorderActivation(data);
        console.log("fourp response ", apiResponse.status);
        if (apiResponse.status) {
          setnotify((prev) => ({
            ...prev,
            show: true,
            type: "success",
            message: "4P GSR Code Activation Succesful",
          }));
          setReorderActivation({
            username: "",
            activation_code: "",
            security_code: "",
          });
          setFourpAccountPV(0);
        } else {
          setnotify((prev) => ({
            ...prev,
            show: true,
            type: "danger",
            message: apiResponse.error.description,
          }));
        }
      }
      setLoadingStates({
        ...loadingStates,
        reorder: false,
      });
    } catch (error) {
      console.log(error);
      setLoadingStates({
        ...loadingStates,
        reorder: false,
      });
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: "Some Error Occured.Please Try Again.",
      }));
    }
  };

  const handleAnotherButtonClick = async () => {
    setLoadingStates({ ...loadingStates, auto_add: true });
    try {
      // Create a new variable and assign the same object values
      if (noOfAccount > 1) {
        setLoadingStates({ ...loadingStates, auto_add: false });
        return setnotify((prev) => ({
          ...prev,
          show: true,
          type: "danger",
          message:
            "The input for the number of 4P accounts to generate should always be 1",
        }));
      }
      const anotherData = {
        access_code: accessCode,
        security_code: securityCode,
        no_of_account: noOfAccount,
        type: "automatic",
      };
      const apiResponse = await service.register(anotherData);
      console.log(
        " ==== api response ==== inside button click",
        apiResponse.status
      );
      console.log({ apiResponse });
      setLoadingStates({ ...loadingStates, auto_add: false });
      if (!apiResponse.status) {
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "danger",
          message: apiResponse.error.description
            ? apiResponse.error.description
            : "Some Error Occured.Please Try Again.",
        }));
      } else {
        setResponse(apiResponse.data.code_details);
        setPv(apiResponse?.data?.current_pv);
        setTotalpv(apiResponse?.data?.required_pv);
        if (apiResponse?.data?.code_details.length == 0) {
          setnotify((prev) => ({
            ...prev,
            show: true,
            type: "danger",
            message: "Empty or Nothing Found.",
          }));
        }
      }

      // Perform other actions with the response
    } catch (error) {
      console.log({ error });
      setLoadingStates({ ...loadingStates, auto_add: false });
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: "Some Error Occured.Please Try Again.",
      }));
    }
  };

  const handleGenerateCode = async () => {
    setIsLoading(true); // Directly set to true instead of toggling
    try {
      console.log("check123456", response);
      let payload = {
        code_array: response,
        no_of_account: noOfAccount,
      };
      console.log(payload.code_array);
      service
        .generateCode(payload)
        .then((res) => {
          console.log("response inside generate code ", res);
          if (res.status) {
            setResponse([]);
            console.log("generate code success response", res.data);
            setnotify((prev) => ({
              ...prev,
              show: true,
              type: "success",
              message: "Code generated successfully!",
            }));
          } else {
            console.log("error inside generate code", res);
            toast.error(); // Display error toast with description
            setnotify((prev) => ({
              ...prev,
              show: true,
              type: "danger",
              message: res.error.description,
            }));
          }
          setIsLoading(false); // Move it inside here
        })
        .catch((error) => {
          // Catch block in case the request fails
          console.error("error fetching data:", error);
          setIsLoading(false);
          toast.error("Failed to generate code!");
          setnotify((prev) => ({
            ...prev,
            show: true,
            type: "danger",
            message: "Some Error Occured. Please Try Again.",
          }));
        });
    } catch (error) {
      console.log(error);
      setIsLoading(false); // Hide the spinner
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: "Unexpected Error. Please Try Again.",
      }));
    }
  };

  //4p registartion
  const handleRegisterSubmit = async () => {
    setLoadingStates({
      ...loadingStates,
      register: true,
    });
    try {
      if (
        accessCodeReg === "" ||
        securityCodeReg === "" ||
        userNameEntry === "" ||
        sponsorUserName === "" ||
        placementUsername === ""
      ) {
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "danger",
          message: "All fields are required for registration.",
        }));
      } else {
        const data = {
          access_code: accessCodeReg,
          security_code: securityCodeReg,
          user_name_entry: userNameEntry,
          sponsor_user_name: sponsorUserName,
          placementUsername: placementUsername,
          position: position,
        };

        const apiResponse = await service.four_P_Register(data);
        console.log(" ==== api response ==== ");
        console.log(apiResponse);
        console.log(" ==== api response ==== ");

        console.log("registration api response", apiResponse);
        if (apiResponse.status) {
          setAccessCodeReg("");
          setSecurityCodeReg("");
          setUserNameEntry("");
          setSponsorUserName("");
          setPlacementUsername("");
          setnotify((prev) => ({
            ...prev,
            show: true,
            type: "success",
            message: "Registration Completed Successfully",
          }));
        } else {
          if (apiResponse.error) {
            setnotify((prev) => ({
              ...prev,
              show: true,
              type: "danger",
              message: apiResponse.error.description,
            }));
          } else {
            setnotify((prev) => ({
              ...prev,
              show: true,
              type: "danger",
              message: "Registration failed",
            }));
          }
        }
      }
      setLoadingStates({
        ...loadingStates,
        register: false,
      });
    } catch (error) {
      console.log(" inside catch error in registration ");
      console.log("error in registration", error);
      setLoadingStates({
        ...loadingStates,
        register: false,
      });
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: "Some Error Occured.Please Try Again.",
      }));
    }
  };

  const getFourpMaintenanceAmount = async (username) => {
    try {
      let data = {
        username: username,
      };
      const response = await service.getFourpMaintenanceAmount(data);
      console.log(response, "maintenance amount response");
      if (response.status) {
        setFourpAccountPV(response.data.pv);
      } else {
        setFourpAccountPV(0);
      }
    } catch (error) {
      setFourpAccountPV(0);
    }
  };

  const debouncedGetFourpMaintenanceAmount = _.debounce((username) => {
    getFourpMaintenanceAmount(username);
  }, 300);

  // useEffect(() =>{
  //   let totalPv =  noOfAccount * 19500;
  //      setTotalpv(totalPv)

  //   },[noOfAccount])
  //const totalPV = response?.reduce((total, entry) => total + entry.pv, 0);
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        props.onClose();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [props.onClose]);

  const handleRemove = (index) => {
    setResponse((prevResponse) => prevResponse.filter((_, i) => i !== index));
  };

  const getTotalPv = () => {
    if (response?.length > 0 && !response?.includes(undefined)) {
      return response.reduce((total, item) => item.pv + total, 0);
    } else {
      return 0;
    }
  };

  const CloseIcon = () => (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  );

  return (
    <div className="modall-wrapper" onClick={handleModalContentClick}>
      <div className="modall" ref={modalRef}>
        <div className="modall-content" onClick={handleModalContentClick}>
          <button className="close-button" onClick={props.onClose}>
            <CloseIcon />
          </button>
          {/*4P Registration */}
          {props.item.id === 1 && (
            <div className="modals" onClick={handleModalContentClick}>
              <div className="bordergreen"></div>
              <div className="headlabel">{props.item.label}</div>
              <div style={{ fontSize: "10px" }}>
                {" "}
                Please enter below details{" "}
              </div>
              <br />
              <br />
              <Form.Group controlId="formCardNo">
                <Form.Label>Activation Code:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Activation Code"
                  value={accessCodeReg}
                  onChange={(e) => setAccessCodeReg(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formCardNo">
                <Form.Label>Security Code:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Security Code"
                  value={securityCodeReg}
                  onChange={(e) => setSecurityCodeReg(e.target.value)}
                />
              </Form.Group>

              <Form.Group controlId="formCardNo">
                <Form.Label>4P Username:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Desired Username"
                  value={userNameEntry}
                  onChange={(e) => {
                    if (e.target.value.startsWith("U_")) {
                      setUserNameEntry(e.target.value);
                    } else {
                      setUserNameEntry("U_" + e.target.value);
                    }
                  }}
                />
              </Form.Group>

              <Form.Group controlId="formCardNo">
                <Form.Label>Placement:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Placement"
                  value={placementUsername}
                  onChange={(e) => setPlacementUsername(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formCardNo">
                <Form.Label>Sponsor:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter sponsor"
                  value={sponsorUserName}
                  onChange={(e) => setSponsorUserName(e.target.value)}
                />
              </Form.Group>
              <Form.Label style={{ fontSize: "12px", marginRight: "10px" }}>
                Placement Position:
              </Form.Label>
              <div style={{ display: "flex" }}>
                <Form.Check
                  type="checkbox"
                  label="Left"
                  value="Left"
                  checked={position === "L"}
                  onChange={(e) => setPosition(e.target.checked ? "L" : "R")}
                  style={{ marginRight: "10px", borderRadius: "50%" }}
                />

                <Form.Check
                  type="checkbox"
                  label="Right"
                  value="Right"
                  checked={position === "R"}
                  onChange={(e) => setPosition(e.target.checked ? "R" : "L")}
                  style={{ marginLeft: "180px", borderRadius: "50%" }}
                />
              </div>

              <br />
              <div style={{ display: "flex" }}>
                <Button
                  style={{
                    fontSize: "14px",
                    borderRadius: "2px",
                    height: "32px",
                    width: "120px",
                  }}
                  variant="success"
                  onClick={ClearFourpRegistration}
                >
                  <strong>Clear</strong>
                </Button>

                <Button
                  style={{
                    fontSize: "14px",
                    marginLeft: "140px",
                    borderRadius: "2px",
                    height: "32px",
                    width: "120px",
                  }}
                  variant="success"
                  onClick={handleRegisterSubmit}
                  disabled={loadingStates.register}
                >
                  <strong>
                    {loadingStates.register ? "Loading" : "Register"}
                  </strong>
                </Button>
              </div>
            </div>
          )}

          {props.item.id === 2 && (
            <div className="modals" onClick={handleModalContentClick}>
              <div className="bordergreen"></div>
              <div className="headlabel">{props.item.label}</div>
              <div style={{ fontSize: "10px" }}>
                Please enter the following details:
              </div>
              <br />
              <br />
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div>
                  <div className="id-two">
                    <Form.Group controlId="formQuantity">
                      <Form.Label>4P Username:</Form.Label>
                      <Form.Control
                        placeholder="Enter Username"
                        type="text"
                        name="username"
                        value={reorderActivation.username}
                        onChange={(e) => {
                          if (e.target.value.startsWith("U_")) {
                            reorderChange(e.target.name, e.target.value);
                          } else {
                            reorderChange(e.target.name, `U_${e.target.value}`);
                          }
                          // reorderChange(e.target.name, e.target.value);
                        }}
                      />
                    </Form.Group>
                    <Form.Group controlId="formPoints">
                      <Form.Label>Activation Code:</Form.Label>
                      <Form.Control
                        placeholder="Enter Activation Code "
                        type="text"
                        // value={accessCode}
                        name="activation_code"
                        value={reorderActivation.activation_code}
                        onChange={(e) => {
                          reorderChange(e.target.name, e.target.value);
                        }}
                      />
                    </Form.Group>
                    <Form.Group controlId="formAmount">
                      <Form.Label>Security Code</Form.Label>
                      <Form.Control
                        placeholder="Enter Security Code "
                        type="text"
                        // value={securityCode}
                        name="security_code"
                        value={reorderActivation.security_code}
                        onChange={(e) => {
                          reorderChange(e.target.name, e.target.value);
                        }}
                      />
                    </Form.Group>
                    <br />
                  </div>
                  <div style={{ display: "flex" }}>
                    <Button
                      style={{
                        fontSize: "10px",
                        borderRadius: "2px",
                        height: "27px",
                        width: "170px",
                        marginLeft: "10px",
                      }}
                      variant="success"
                      onClick={() => {
                        clearReorder();
                      }}
                    >
                      <strong>clear</strong>
                    </Button>
                    <Button
                      style={{
                        fontSize: "10px",
                        borderRadius: "2px",
                        marginLeft: "10px",
                        height: "27px",
                        width: "170px",
                      }}
                      variant="success"
                      onClick={codeActivationSubmit}
                      disabled={loadingStates.reorder}
                    >
                      <strong>
                        {loadingStates.reorder ? "Loading" : "Activate"}
                      </strong>
                    </Button>
                  </div>
                </div>
                <div id="pvdetails">
                  <div className="ewalletTiles center">
                    <div
                      className={`${
                        currentTheme === "theme-dark"
                          ? `dark_mode_Tiles d-flex`
                          : `Tiles d-flex`
                      }`}
                    >
                      <div
                        className={`${
                          currentTheme === "theme-dark"
                            ? `dark_mode_tilesData`
                            : `tilesData`
                        }`}
                      >
                        <h4>
                          <strong>Total PV For The Month</strong>
                        </h4>
                        <br />
                        <input
                          type="text"
                          value={fourpAccountPV}
                          readonly
                          className="TilesAmount"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* 4P CODE GENERATOR MODAL */}
          {props.item.id === 4 && (
            <div
              className="modals"
              style={{ maxHeight, overflowY: "auto" }}
              onClick={handleModalContentClick}
            >
              <div className="bordergreen"></div>
              <div className="headlabel">4P Code Generator</div>

              <div style={{ fontSize: "10px" }}>
                Please enter below details:
              </div>

              <br />

              <div className="id-two">
                <div style={{ display: "flex" }}>
                  <Form.Group controlId="formPointsToTransfer">
                    <Form.Label style={{ fontSize: "10px" }}>
                      <div>No. of 4P Account to Generate:</div>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      onChange={(e) => setNoOfAccount(e.target.value)}
                      value={noOfAccount}
                      disabled={true}
                    />
                  </Form.Group>
                  <div>
                    <Form.Group controlId="formPointsToTransfer">
                      <Form.Label
                        style={{ fontSize: "10px", marginLeft: "50px" }}
                      >
                        <div className="labelname">Total PV:</div>
                      </Form.Label>
                      <Form.Control
                        disabled
                        style={{
                          width: "100px",
                          marginLeft: "50px",
                          height: "50px",
                        }}
                        value={getTotalPv()}
                      />
                    </Form.Group>
                  </div>
                </div>

                <Form.Group
                  style={{ marginTop: "-30px" }}
                  controlId="formPointsToTransfer"
                >
                  <Form.Label>
                    <div>Activation Code:</div>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={accessCode}
                    onChange={(e) => setAccessCode(e.target.value)}
                  />
                </Form.Group>
                <Form.Group controlId="formPointsToTransfer">
                  <Form.Label>
                    <div>Security Code:</div>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => setSecurityCode(e.target.value)}
                    value={securityCode}
                  />
                </Form.Group>
              </div>
              <div style={{ display: "flex" }}>
                <Button
                  onClick={handleAnotherButtonClick}
                  style={{
                    marginLeft: "10px",
                    background: "#28a745",

                    fontSize: "10px",
                    borderRadius: "2px",
                    height: "27px",
                    width: "100px",
                  }}
                  // variant="success"
                  disabled={loadingStates.auto_add}
                >
                  <strong>{loadingStates.auto_add ? "Loading" : "Auto"}</strong>
                </Button>

                <Button
                  style={{
                    fontSize: "10px",
                    borderRadius: "2px",
                    height: "27px",
                    width: "100px",
                    marginLeft: "10px",
                  }}
                  variant="primary"
                  onClick={handleSubmit}
                  disabled={loadingStates.add}
                >
                  <strong>{loadingStates.add ? "Loading" : "Add"}</strong>
                </Button>
              </div>
              <br />
              <div
                className="table-container"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  className="table"
                  style={{
                    maxHeight: maxHeight == 280 ? "150px" : "300px",
                    overflowY: "auto",
                  }}
                >
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>
                          <div>Activation Code</div>
                        </th>
                        <th>
                          <div>Security Code</div>
                        </th>
                        <th>
                          <div>Product Name</div>
                        </th>
                        <th>
                          <div>4P PV</div>
                        </th>
                        <th>
                          <div>Action</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingStates.add === false &&
                      loadingStates.auto_add === false
                        ? response.map((entry, index) => (
                            <tr key={index}>
                              <td>
                                <div>{entry?.access_code}</div>
                              </td>
                              <td>
                                <div>{entry?.security_code}</div>
                              </td>
                              <td>
                                <div>{entry?.name}</div>
                              </td>
                              <td>
                                <div>{entry?.pv}</div>
                              </td>
                              <td>
                                <button
                                  variant="danger"
                                  onClick={() => handleRemove(index)}
                                  style={{
                                    fontSize: "small",
                                    fontWeight: "bold",
                                    background: "red",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "small",
                                      fontWeight: "bold",
                                      marginTop: "-7px",
                                    }}
                                  >
                                    Remove
                                  </div>
                                </button>
                              </td>
                            </tr>
                          ))
                        : "Loading"}
                    </tbody>
                  </Table>
                </div>
              </div>

              <br />
              <br />
              <div
              // style={{
              //   display: "flex",
              //   justifyContent: "center",
              //   marginTop: "10px",
              // }}
              >
                {getTotalPv() >= totalPv && (
                  <Button
                    onClick={handleGenerateCode}
                    style={{
                      fontSize: "12px",
                      borderRadius: "2px",
                      height: "35px",
                      width: "190px",
                      // marginLeft: "230px",
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "block",
                      marginBottom: "10px",
                    }}
                    variant="primary"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <Spinner animation="border" size="sm" /> Generating
                        Code...
                      </>
                    ) : (
                      <strong>Generate Code</strong>
                    )}
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {notify.show && (
        <div onClick={handleModalContentClick}>
          <AlertMessage
            message={notify.message}
            dismiss={notifyDissmissed}
            type={notify.type}
            header={notify.header}
            show={notify.show}
          />
        </div>
      )}
      {/* <ToastContainer /> */}
    </div>
  );
}

export default IlifeModal;
